module.exports = __webpack_public_path__ + "img/pose-f-28.aa8daede.png";